import {
  Button,
  Card,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { Add, Edit } from "@mui/icons-material";
import TableComponent from "components/_refactor/table/table";
import { columnTextField } from "utils/tables-utils";

export default function TableFranquias({ data, onEdit, onCreate }) {
  const columnModel = [
    columnTextField({
      dataField: "IdFranquiaConfiguracao",
      text: "Id franquia",
      align: "center",
    }),
    columnTextField({
      dataField: "NomePessoaLoja",
      text: "Nome",
    }),
    columnTextField({
      dataField: "SchemaBaseSeta",
      text: "Schema Base Seta",
    }),
    columnTextField({
      dataField: "NomeGrupoEconomico",
      text: "Grupo Econômico",
    }),
    columnTextField({
      dataField: "Ativo",
      text: "Status",
      formatter: (_, row) => {
        return (
          <Chip
            label={row.Ativo ? "Ativo" : "Inativo"}
            size="small"
            style={{
              width: "100px",
              padding: "1rem 0.5rem",
              backgroundColor: row.Ativo
                ? "rgba(0, 128, 0, 0.1)"
                : "rgba(255, 56, 96, 0.1)",
              border: row.Ativo
                ? "1px solid rgba(0, 128, 0, 0.5)"
                : "1px solid rgba(255, 56, 96, 0.5)",
            }}
          />
        );
      },
    }),
    columnTextField({
      dataField: "Ações",
      text: "Ações",
      align: "center",
      formatter: (_, row) => {
        return (
          <Tooltip title="Editar Franquia">
            <IconButton
              size="small"
              color="primary"
              onClick={() => onEdit(row)}
            >
              <Edit />
            </IconButton>
          </Tooltip>
        );
      },
    }),
  ];

  return (
    <Card>
      <CardContent>
        <TableComponent
          dataTable={data}
          columnModel={columnModel}
          keyField="IdFranquiaConfiguracao"
          headerTitle="Administração de Franquias"
          pagination={{
            options: [25, 50, 100],
            sizePerPage: 25,
            showTotal: true,
          }}
          notFoundTitle="Sua pesquisa não encontrou nenhum resultado."
          notFoundSubtitle="Tente ajustar os filtros de busca."
          extraActions={
            <Button variant="contained" onClick={onCreate}>
              <Add /> Incluir Nova Franquia
            </Button>
          }
        />
      </CardContent>
    </Card>
  );
}
